import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'
import { useRouteMatch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'
import { CBOS_ACESSO_CC } from 'types/NivelCbo'
import Permissions from 'types/Permissions'
import { CuidadosCompartilhadosRootView } from 'view/cuidados-compartilhados/CuidadosCompartilhadosRootView'
import { getTiposEstabelecimentoCuidadoCompartilhado } from 'view/cuidados-compartilhados/util-cuidadoCompartilhado'

import { GarantiaAcessoRootView } from './GarantiaAcessoRootView'

export const GestaoFilasRootView = () => {
  const { PILOTO_VINCULACAO_CUIDADO_ENABLED, PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()
  const match = useRouteMatch()

  return (
    <PecSwitch>
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
        <Redirect exact from={match.url} to={`${match.url}/garantia-acesso/demanda-reprimida`} />
      )}
      <PrivateRoute
        path={`${match.url}/cuidados-compartilhados`}
        component={CuidadosCompartilhadosRootView}
        tiposEstabelecimento={getTiposEstabelecimentoCuidadoCompartilhado(PILOTO_VINCULACAO_CUIDADO_ENABLED)}
        cbos={CBOS_ACESSO_CC}
        permission={Permissions.cuidadoCompartilhado}
      />
      <Route path={`${match.url}`} component={GarantiaAcessoRootView} />
    </PecSwitch>
  )
}
